import React from "react";
import { Box } from "@mui/material";

const MapSection = () => (
  <Box>
    <iframe
      title="Google Map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233335.85322589307!2d39.16184531624168!3d21.542393213476633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cdb1e5d5c209%3A0xf2af54f2da6c4e05!2sAl%20Waha%2C%20Jeddah%2023391%2C%20Saudi%20Arabia!5e0!3m2!1sen!2ssa!4v1634794321664!5m2!1sen!2ssa"
      width="100%"
      height="450px"
      style={{ border: "none" }}
      loading="lazy"
    ></iframe>
  </Box>
);

export default MapSection;
